import React from 'react';
import CigecpeCard from './fedigitalcertificateCard';
import img1 from '../../../public/images/CERTIFICADO-768x392.png';

import Button from '../Button';

const Cigecpe = () => {
  return (
    <div className="min-h-screen container mx-auto flex flex-col items-center justify-center mt-16 mb-8 px-5 lg:px-0">
      <h1 className="text-4xl lg:text-5xl font-bold text-center text-blue mb-10">
        Certificado Digital FE
      </h1>

      <div className="w-full lg:w-3/4 space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <CigecpeCard
            img={img1}
            title0=""
            title1=""
            description=""
            items={[]}
          />
          <CigecpeCard
            title0=""
            title1="Certificado Digital para Factura Electrónica según los Requisitos de la SUNAT"
            description="Certificado digital para facturación electrónica que permite firmar documentos XML con los estándares que la SUNAT exige en el Perú para emitir Facturas Electrónicas, Boletas de Ventas Electrónicas y las Notas Electrónicas (Crédito y Débito), Comprobantes de Percepción y Retención, conforme lo establece el artículo 1° de la Resolución de Superintendencia N° 097-2012/SUNAT y modificatorias."
            items={[]}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <CigecpeCard
            title0="Nuevo"
            title1="Vigencia: 1 Año"
            title2=""
            title3="S/ 354"
            title4="S/ 295"
            title5="* Precio Incluye IGV"
            description=""
            items={[
              'Emitimos una Factura Electrónica a nombre de su empresa.'
            ]}
          />

          <CigecpeCard
            title0="Nuevo"
            title1="Vigencia: 2 Años"
            title2=""
            title3="S/ 590.00"
            title4="S/ 501.50"
            title5="* Precio Incluye IGV"
            description=""
            items={[
              'Emitimos una Factura Electrónica a nombre de su empresa.'
            ]}
          />
          
          <CigecpeCard
            title0="Nuevo"
            title1="Vigencia: 3 Años"
            title2=""
            title3="S/ 826.00"
            title4="S/ 708.00"
            title5="* Precio Incluye IGV"
            description=""
            items={[
              'Emitimos una Factura Electrónica a nombre de su empresa.'
            ]}
          />          

          <CigecpeCard
            title0=""
            title1="CARACTERÍSTICAS"
            description=""
            items={[

'Emitido como un certificado de Agente Automatizado para proceso de facturación electrónica de su empresa.',
'Certificado emitido por una Entidad de Certificación incorporado en la TSL de INDECOPI.',
'Permiten firmar documentos XML (UBL).',
'Generado con el estándar X.509 v3, SHA2 y RSA de 2048 bits.',
'Formato .PFX, .P12 y .CER. En este Link puede convertir el certificado en formato .CER, que es lo que pide la SUNAT. (Convertir .PFX a formato .CER).',
'Compatible con el FACTURADOR SUNAT, sistemas propios y terceros.',
'Este certificado también es para los Proveedores de Servicios Electrónicos PSE.'
            ]}
          />


          <CigecpeCard
            title0=""
            title1="REQUISITOS"
            description=""
            items={[

'DNI y/o CE vigente.',
'No contar con multas ante JNE.',
'Ficha RUC con código QR (no mayor a 7 días de antigüedad).',
'Vigencia poder/copia literal con código QR (no mayor a 3 meses de antigüedad).',
'Validación de identidad.'
            ]}
          />

          <CigecpeCard
            title0=""
            title1="TIEMPO DE ENTREGA"
            description="La entrega del certificado es INMEDIATA en cuanto validemos la identidad del solicitante y realice el pago (IMPORTANTE: la identidad puede validarse en minutos o de 1 a 2 días hábiles). Se le enviará el Certificado a través de un ambiente seguro y cifrado (nadie tendrá acceso al certificado o la clave privada, eso nos incluye a nosotros)."
            items={[]}
          />
          
        </div>
      </div>
    </div>
  );
};

export default Cigecpe;
